// Media views (Images / Documents / All files) on the Retailers list scope the list to retailers
// that have the matching media by applying an Advanced Search boolean. Each view maps to its own
// filter — Images → `has_images`, Documents → `has_documents`, All files → `has_media` — so every
// tab carries a single, distinct filter/chip. This keeps the list, filter chips, URL and Advanced
// Search drawer in sync. Shared by the new design (sidebar tabs) and the old design (kind pills),
// keyed on the media `kind` value they both already compute ('images' | 'docs' | 'all').
const KIND_MEDIA_FILTERS = {
  images: { has_images: '1' },
  docs: { has_documents: '1' },
  all: { has_media: '1' },
};

/**
 * Returns a new filter object for the given media `kind`, preserving every other applied filter.
 * All three media keys are stripped first, then the one matching the kind is set — so switching
 * kinds never leaves a stale `has_images` / `has_documents` / `has_media` behind. Note `applyFilters`
 * replaces the whole filter slice, so callers pass the full returned object.
 */
export const mediaKindFilters = (generalFilters = {}, kind) => {
  const next = { ...generalFilters };
  delete next.has_images;
  delete next.has_documents;
  delete next.has_media;
  return { ...next, ...(KIND_MEDIA_FILTERS[kind] || {}) };
};

/**
 * The same filter object with all three media keys dropped and nothing put back — what a page applies
 * on its way OUT of a media view (Images / Documents / All files) to List, Map or any other section.
 *
 * The media filter only makes sense while a media view is on screen: left behind, its chip ("Only show
 * retailers that have visits with images") keeps narrowing the retailer/visit list from a section that
 * never mentions media, and reads as a filter the user set by hand. Every other applied filter is
 * preserved — only the tab's own scoping is undone.
 */
export const withoutMediaFilters = (generalFilters = {}) => mediaKindFilters(generalFilters, null);
